import React, { useCallback, useState } from 'react';
import { TypographySmall } from '@/Components/shadcn/typography';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/Components/shadcn/tooltip';
import { cn } from '@/lib/utils';

export interface TooltipTypographyProps extends React.ComponentPropsWithoutRef<'span'> {
    boxContainerProps?: React.ComponentPropsWithoutRef<'div'>;
}

const TooltipTypography = ({ children, className, boxContainerProps, ...props }: TooltipTypographyProps) => {
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useCallback(
        (node: HTMLSpanElement) => {
            // uncomment to enable the tooltip feature
            // setIsOverflowing(node?.scrollWidth > node?.clientWidth);
        },
        [setIsOverflowing],
    );
    const { className: containerClassName, ...restContainer } = boxContainerProps ?? {};

    return (
        <div className={cn('w-full', containerClassName)} {...restContainer}>
            <TooltipProvider>
                <Tooltip open={isOverflowing ? undefined : false}>
                    <TooltipTrigger asChild>
                        <TypographySmall
                            ref={textRef}
                            className={cn('text-foreground block max-w-full cursor-default truncate', className)}
                            {...props}
                        >
                            {children}
                        </TypographySmall>
                    </TooltipTrigger>
                    <TooltipContent className="max-w-sm">{children}</TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
};

export default TooltipTypography;
